import { useContext, useEffect, useState } from "react";
import { ScrollView, Text, View } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import GooglePlacesInput from "../../components/GooglePlacesInput";
import PageTitle from "../../components/PageTitle";
import { GlobalContext } from "../../contexts/global";
import { calcCrow } from "../../helpers/util";
import useLocation from "../../hooks/useLocation";
import useMapUnitys from "../../hooks/useMapUnitys";
import { UnitiesMap } from "../../services/Api/unity";
import {
  CIRCLE_RADIUS_INITIAL,
  MAP_REGION_INITIAL,
} from "../../services/Config";
import * as Colors from "../../styles/colors";
import * as Fonts from "../../styles/typography";
import SliderDistance from "./components/SliderDistance";
import UnityItem from "./components/UnityItem";
import { useNavigation } from "@react-navigation/native";

export default function UnityList({ navigation }) {
  const { setLoading, setShowAlert, showAlert } = useContext(GlobalContext);
  const [marker, setMarker] = useState(MAP_REGION_INITIAL);
  const [radiosCircle, setRadiusCircle] = useState(CIRCLE_RADIUS_INITIAL);
  useEffect(
    () => setLoading({ show: true, message: "Carregando unidades" }),
    []
  );
  const [jsonUnitiesMap, setJsonUnitiesMap] = useState(null);
  const showAllUnities = radiosCircle > 18000;
  const deviceLocation = useLocation();
  const { data, isLoading, isSuccess } = useMapUnitys(marker, 0);
  navigation = useNavigation();
  useEffect(() => {
    if (!!deviceLocation) {
      setMarker(deviceLocation);
      setLoading({ show: false, message: "Carregando unidades" });
    }
  }, [deviceLocation]);

  useEffect(() => {
    if (isSuccess) {
      setJsonUnitiesMap(data);
    }
  }, [isSuccess]);

  const unitiesFilter = jsonUnitiesMap
    ? jsonUnitiesMap.filter(
        (unity) =>
          calcCrow(
            marker.latitude,
            marker.longitude,
            unity.latitude,
            unity.longitude
          ) <
            radiosCircle / 1000 || radiosCircle >= 21000
      )
    : [];

  const onPressItem = (unity) => {
    navigation.navigate("Contract", unity);
  };

  return (
    <PageTitle title={"Estacionamentos"}>
      <View style={{ flex: 1 }}>
        <SliderDistance
          radiosCircle={radiosCircle}
          setRadiosCircle={setRadiusCircle}
        />
        <View
          style={{
            alignItems: "center",
            marginBottom: 8,
          }}
        >
          <Text
            style={{
              fontSize: Fonts.FONT_SIZE_16,
            }}
          >{`Estacionamentos Encontrados ${unitiesFilter.length}`}</Text>
        </View>
        {unitiesFilter.length > 0 ? (
          <ScrollView style={{ width: "100%" }}>
            {unitiesFilter.map((unity) => {
              return (
                <UnityItem
                  name={unity.name}
                  address={unity.address.toUpperCase()}
                  value={"R$200,00"}
                  key={unity.id}
                  onPress={() =>
                    onPressItem({ name: unity.name, id: unity.id })
                  }
                />
              );
            })}
          </ScrollView>
        ) : (
          <View
            style={{
              alignItems: "center",
              justifyContent: "center",
              flex: 1,
              flexGrow: 1,
            }}
          >
            <Icon name="garage" size={128} color={Colors.BLACK} />
            <Text style={{ marginTop: 24, fontSize: Fonts.FONT_SIZE_16 }}>
              {"Nenhum estacionamento encontrado."}
            </Text>
          </View>
        )}
        <View
          style={{
            position: "absolute",
            width: "100%",
          }}
        >
          <GooglePlacesInput
            setLoading={setLoading}
            setMarker={setMarker}
            setRadiosCircle={setRadiusCircle}
          />
        </View>
      </View>
    </PageTitle>
  );
}
